export default function HawaiiIntro() {
  const islands = [
    {
      name: 'Oahu',
      title: 'Trung tâm Hawaii',
      description: 'Waikiki - Đại lộ Kalakaua - Trân Châu Cảng - Trung tâm văn hóa Polynesian',
      image: 'https://public.readdy.ai/ai/img_res/65223d5d8411697ac022bc3e8cd90cfa.jpg',
      color: 'from-blue-500 to-cyan-400',
      highlights: ['Waikiki', 'Trân Châu Cảng', 'Polynesian']
    },
    {
      name: 'Maui',
      title: 'Thiên đường biển',
      description: 'Hana Road lãng mạn - Bãi biển tuyệt đẹp - Ngắm cá voi - Haleakalā',
      image: 'https://readdy.ai/api/search-image?query=Breathtaking%20scenic%20view%20of%20the%20famous%20Road%20to%20Hana%20in%20Maui%20Hawaii%2C%20winding%20coastal%20highway%20with%20lush%20tropical%20rainforest%2C%20cascading%20waterfalls%2C%20dramatic%20ocean%20cliffs%2C%20turquoise%20Pacific%20waters%2C%20romantic%20tropical%20landscape%2C%20vibrant%20green%20vegetation%2C%20misty%20mountains%2C%20professional%20travel%20photography&width=800&height=600&seq=maui-1&orientation=landscape',
      color: 'from-teal-500 to-green-400',
      highlights: ['Hana Road', 'Bãi biển', 'Haleakalā']
    },
    {
      name: 'Đảo Lớn',
      title: 'Núi lửa & Thiên nhiên',
      description: 'Công viên núi lửa - Dung nham - Cà phê Kona - Bãi cát đen - Thiên nhiên nguyên sơ',
      image: 'https://readdy.ai/api/search-image?query=Dramatic%20volcanic%20landscape%20of%20Big%20Island%20Hawaii%20with%20active%20lava%20flows%2C%20glowing%20red%20molten%20lava%2C%20volcanic%20craters%2C%20black%20sand%20beaches%2C%20steam%20rising%20from%20ocean%2C%20rugged%20volcanic%20terrain%2C%20Kona%20coffee%20plantations%20on%20slopes%2C%20pristine%20natural%20wilderness%2C%20epic%20geological%20formations%2C%20professional%20nature%20photography&width=800&height=600&seq=bigisland-1&orientation=landscape',
      color: 'from-orange-500 to-red-400',
      highlights: ['Núi lửa', 'Bãi cát đen', 'Cà phê Kona']
    }
  ];

  return (
    <section id="hawaii-intro" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Khám phá <span className="text-[#2563eb]">Hawaii 2026</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Hành trình qua 3 đảo tuyệt đẹp giữa Thái Bình Dương
          </p>
        </div>

        {/* Islands Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {islands.map((island, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group"
            >
              {/* Image */}
              <div className="relative h-56 overflow-hidden">
                <img
                  src={island.image}
                  alt={island.name}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <h3 className="absolute bottom-4 left-4 text-2xl font-bold text-white">{island.name}</h3>
              </div>

              {/* Content */}
              <div className="p-6">
                <p className="text-gray-600 mb-4">{island.description}</p>
                <div className="flex flex-wrap gap-2">
                  {island.highlights.map((highlight, idx) => (
                    <span
                      key={idx}
                      className="px-3 py-1 bg-[#dbeafe] text-[#2563eb] rounded-full text-sm font-medium"
                    >
                      {highlight}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Features */}
        <div className="mt-16 bg-gradient-to-r from-blue-50 to-teal-50 rounded-3xl p-8 sm:p-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="flex items-start">
              <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center mr-4 flex-shrink-0">
                <i className="ri-landscape-line text-white text-2xl"></i>
              </div>
              <div>
                <h4 className="text-xl font-bold text-gray-900 mb-2">Phong cảnh tuyệt đẹp</h4>
                <p className="text-gray-600">Thác nước, rừng nhiệt đới, biển xanh trong, bãi cát đen độc đáo</p>
              </div>
            </div>
            <div className="flex items-start">
              <div className="w-12 h-12 bg-teal-600 rounded-xl flex items-center justify-center mr-4 flex-shrink-0">
                <i className="ri-music-2-line text-white text-2xl"></i>
              </div>
              <div>
                <h4 className="text-xl font-bold text-gray-900 mb-2">Văn hóa Polynesia</h4>
                <p className="text-gray-600">Trải nghiệm văn hóa truyền thống - Show đặc sắc - Ẩm thực bản địa</p>
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <a
            href="#itinerary"
            className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-[#2563eb] to-[#3b82f6] text-white rounded-full font-bold text-lg hover:shadow-xl transition-all duration-300 hover:scale-105 cursor-pointer"
          >
            Khám phá hành trình ngay
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
